import { useContext } from 'react';

import axios from 'axios';

import { useAppDispatch } from '../../../../../../store/hooks';
import { ReactComponent as CheckmarkIcon } from '../../../../../shared/assets/icons/snackbar-icons/check-mark.svg';
import { ReactComponent as WarningIcon } from '../../../../../shared/assets/icons/snackbar-icons/warning.svg';
import { ChangeDetectorContext } from '../../../../../shared/components/change-detector-context/ChangeDetectorContext';
import { SnackBarContext } from '../../../../../shared/components/snack-bar-context/SnackBarContext';
import { SnackBarContextModel } from '../../../../../shared/components/snack-bar-context/models/snack-bar-context.model';
import { AsyncThunkFunctionModel } from '../../../../../shared/models/async-thunk-function.model';
import { ReleaseRequestModel } from '../../../../models/release-request.model';
import { ReleaseModel } from '../../../../models/release.model';
import { releasesSlice } from '../../../../store/slices/releases.slice';
import { ReleasesFormikModel } from '../../models/releases-formik.model';
import { useGetReleasesFormSelectors } from '../use-get-releases-form-selectors/use-get-releases-form-selectors.hook';

export const useOnSubmitReleasesForm = (
  appId: number,
  handleSubmit: AsyncThunkFunctionModel<ReleaseModel, ReleaseRequestModel>,
  changeFormState?: (
    state: boolean | ((prevState: boolean) => boolean)
  ) => void,
  data?: ReleaseModel
): ((values: Partial<ReleasesFormikModel>) => Promise<void>) => {
  const dispatch = useAppDispatch();
  const cdContext = useContext(ChangeDetectorContext);
  const snackBarContext = useContext(SnackBarContext) as SnackBarContextModel;
  const { apksIds } = useGetReleasesFormSelectors();
  return async (values: Partial<ReleasesFormikModel>): Promise<void> => {
    try {
      await dispatch(
        handleSubmit({
          apkFilesIds: apksIds,
          description: values.description!,
          status: values.status!.label,
          id: data ? data.id : appId,
        })
      ).unwrap();
      snackBarContext.changeIcon(<CheckmarkIcon />);
      snackBarContext.changeSeverity('success');
      snackBarContext.changeMessage(
        `Successfully ${data ? 'updated' : 'created'} the release !`
      );
      cdContext?.setIsChanged(false);
      changeFormState?.(false);
    } catch (err) {
      dispatch(releasesSlice.actions.setHasReleasesFormError(true));
      let errorMsg = `Something went wrong while ${
        data ? 'updating' : 'creating'
      } the release !`;

      if (axios.isAxiosError(err)) {
        errorMsg = err.message;
      }
      snackBarContext.changeIcon(<WarningIcon />);
      snackBarContext.changeSeverity('error');
      snackBarContext.changeMessage(errorMsg);
    }

    snackBarContext.isOpen(true);
  };
};
